import siteLoaderTheme from './siteLoaderTheme';

const siteLoaderDarkTheme = {
    loader: {
        ...siteLoaderTheme.loader,
    },
};

export default siteLoaderDarkTheme;
